// extracted by mini-css-extract-plugin
export var ageGateBase = "age-gate-module--ageGateBase--108da";
export var ageGateBody = "age-gate-module--ageGateBody--cbe96";
export var ageGateInternal = "age-gate-module--ageGateInternal--55d14";
export var allowCookies = "age-gate-module--allowCookies--1d284";
export var buttonRow = "age-gate-module--buttonRow--9d9a1";
export var cookieContainer = "age-gate-module--cookie-container--68277";
export var privacyPolicy = "age-gate-module--privacy-policy--fa412";